"use client";

import { c as _c } from "react/compiler-runtime";
import { Item, ItemAvatar, ItemContent } from "@opensea/next-ui-kit";
import { Checkbox, classNames, SkeletonBlock, SkeletonLine, TableCell, TableRow, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { keys } from "@opensea/utils";
import { useIsOwnProfileAddress } from "@/components/profile/ProfileAddressProvider";
import { PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES } from "./styles";
export function ProfileItemsTableSkeletonRow(t0) {
  const $ = _c(27);
  const {
    overrides
  } = t0;
  const {
    size
  } = useTable();
  const {
    image
  } = tableRowSizeVariants({
    size
  });
  const isOwnProfileAddress = useIsOwnProfileAddress();
  const T0 = TableRow;
  let t1;
  if ($[0] !== isOwnProfileAddress) {
    t1 = isOwnProfileAddress ? <TableCell className={PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES.checkbox}><Checkbox /></TableCell> : null;
    $[0] = isOwnProfileAddress;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const T1 = TableCell;
  const t2 = PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES;
  const T2 = Item;
  const t3 = "unstyled";
  const T3 = ItemAvatar;
  const t4 = image();
  const t5 = overrides?.Skeleton?.className;
  let t6;
  if ($[2] !== t5) {
    t6 = <SkeletonBlock className={t5} />;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== T3 || $[5] !== t4 || $[6] !== t6) {
    t7 = <T3 className={t4}>{t6}</T3>;
    $[4] = T3;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = overrides?.Skeleton?.className;
  let t9;
  if ($[8] !== t8) {
    t9 = classNames("w-1/2", t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <ItemContent><SkeletonLine className={t9} /></ItemContent>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== T2 || $[13] !== t10 || $[14] !== t7) {
    t11 = <T2 variant={t3}>{t7}{t10}</T2>;
    $[12] = T2;
    $[13] = t10;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== T1 || $[17] !== t11 || $[18] !== t2.item) {
    t12 = <T1 className={t2.item}>{t11}</T1>;
    $[16] = T1;
    $[17] = t11;
    $[18] = t2.item;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== overrides?.Skeleton?.className) {
    t13 = keys(PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES).slice(2).map(key => <TableCell className={PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES[key]} key={key}><SkeletonLine className={classNames("w-1/2", overrides?.Skeleton?.className)} /></TableCell>);
    $[20] = overrides?.Skeleton?.className;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== T0 || $[23] !== t1 || $[24] !== t12 || $[25] !== t13) {
    t14 = <T0>{t1}{t12}{t13}</T0>;
    $[22] = T0;
    $[23] = t1;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}